module.exports = __webpack_public_path__ + "static/media/slide2.62a500ed.png";